"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadLicenseFilesAzZip = exports.constructIdForLicense = void 0;

var _file = require("../../skybase-core/utils/file");

var _fileSave = require("../../skybase-core/services/file-save");

var JSZip = require('jszip');

var removeCharsFromString = function removeCharsFromString(string) {
  return string.replace(/[^\w\s!?]/g, '');
};
/**
 * Create a custom ID for every license file. If parentId provided, the final ID will be prefixed with it.
 * @param parentId
 * @param name
 * @param version
 * @param fileName
 * @returns {*}
 */


var constructIdForLicense = function constructIdForLicense(parentId, name, version, fileName) {
  var fileNameFromPath = (0, _file.getFileNameFromPath)(fileName);
  var defaultId = removeCharsFromString(name + version + fileNameFromPath);
  return parentId ? parentId + defaultId : defaultId;
};
/**
 * Fetches all given files, constructs a zip file and downloads it for the client.
 * @param {Array} files
 * @param {String} moduleName
 * @param {String} path
 */


exports.constructIdForLicense = constructIdForLicense;

var downloadLicenseFilesAzZip = function downloadLicenseFilesAzZip(files, moduleName, path) {
  var contents = [];
  var promiseList = [];
  files.forEach(function (url, i) {
    promiseList.push(fetch("".concat(path, "/").concat(url)).then(function (res) {
      return res.blob();
    }).then(function (res) {
      contents[i] = {
        file: res,
        fileName: (0, _file.getFileNameFromPath)(url.replace(/\\/g, '/')) // replacing backslashes with forward slashes for Windows compatiblity

      };
    }));
  });
  Promise.all(promiseList).then(function () {
    var zip = new JSZip();
    contents.forEach(function (_ref) {
      var file = _ref.file,
          fileName = _ref.fileName;
      zip.file(fileName, file);
    });
    zip.generateAsync({
      type: 'blob'
    }).then(function (blob) {
      (0, _fileSave.saveAs)("".concat(moduleName, ".zip"), blob);
    });
  });
};

exports.downloadLicenseFilesAzZip = downloadLicenseFilesAzZip;
//# sourceMappingURL=utils.js.map